import { render, staticRenderFns } from "./onlineCall.vue?vue&type=template&id=3cbdc18c&scoped=true"
import script from "./onlineCall.vue?vue&type=script&lang=js"
export * from "./onlineCall.vue?vue&type=script&lang=js"
import style0 from "./onlineCall.vue?vue&type=style&index=0&id=3cbdc18c&prod&lang=scss&scoped=true"
import style1 from "./onlineCall.vue?vue&type=style&index=1&id=3cbdc18c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbdc18c",
  null
  
)

export default component.exports